import { Component } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, delay } from 'rxjs/operators';

@Component({
  selector: 'app-confirmar-usuario-clave',
  templateUrl: './confirmar-usuario-clave.component.html',
  styleUrl: './confirmar-usuario-clave.component.css',
  animations: [ 
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1000ms ease-in', style({ opacity: 2 })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})

export class ConfirmarUsuarioClaveComponent {
  form: FormGroup;
  showInputs: boolean = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      nombreUsuario: ['', [Validators.required, this.noCaracteresEspecialesValidator()], [this.nombreUsuarioAsyncValidator()]],
      clave: ['', [Validators.required, this.passwordStrengthValidator()]],
      RepitaClave: ['', Validators.required]
    }, {
      validators: this.passwordsMatchValidator()
    });
  }
  
  // Validador para prohibir caracteres especiales en nombreUsuario
  noCaracteresEspecialesValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const regex = /^[a-zA-Z0-9]*$/;
      const valid = regex.test(control.value);
      return valid ? null : { caracteresEspeciales: true };
    };
  }

  // Validador asíncrono con retraso para nombreUsuario
  nombreUsuarioAsyncValidator() {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return of(control.value).pipe(
        delay(500), // Simula un retraso de 500ms
        map(value => {
          // Lógica de validación asíncrona (por ejemplo, verificar disponibilidad en el servidor)
          const nombreUsuarioDisponible = true; // Cambia esto según tu lógica
          return nombreUsuarioDisponible ? null : { nombreNoDisponible: true };
        })
      );
    };
  }

  // Validador para verificar la fortaleza de la contraseña
  passwordStrengthValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
      const valid = hasUpperCase && hasLowerCase && hasSpecialChar;
      return valid ? null : { passwordStrength: true };
    };
  }

  // Validador para verificar que las contraseñas coincidan
  passwordsMatchValidator() {
    return (group: AbstractControl): ValidationErrors | null => {
      const password = group.get('clave')?.value;
      const confirmPassword = group.get('RepitaClave')?.value;
      return password === confirmPassword ? null : { passwordsMismatch: true };
    };
  }

  onSubmit(): void {
    this.form.markAllAsTouched();
  }

}
